"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PayChart;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const ThemeContext_1 = require("../ThemeContext");
const Helper_1 = require("../Helper");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        bar: {
            alignSelf: 'center',
            flexDirection: 'row',
            height: 30,
            justifyContent: 'center',
            width: '100%'
        },
        legendItem: {
            alignItems: 'center',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center'
        },
        legendLabel: {
            color: THEME.Text,
            fontSize: 12,
            fontWeight: '500'
        },
        legendTotal: {
            color: THEME.Text,
            fontSize: 12
        }
    });
};
function PayChart(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const deductionsPct = (props.deductions / props.grossPay) * 100;
    const taxesPct = (props.taxes / props.grossPay) * 100;
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.bar, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                            width: `${((props.netPay / props.grossPay) * 100)}%`,
                            backgroundColor: THEME.Secondary
                        }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                            width: `${deductionsPct}%`,
                            backgroundColor: '#f6b93b',
                            borderLeftColor: THEME.CardBackground,
                            borderLeftWidth: deductionsPct > 0 ? 2 : 0,
                        }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                            width: `${taxesPct}%`,
                            backgroundColor: '#e55039',
                            borderLeftColor: THEME.CardBackground,
                            borderLeftWidth: taxesPct > 0 ? 2 : 0,
                        }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', marginVertical: 6 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { backgroundColor: THEME.Secondary, marginRight: 6, marginTop: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 10, height: 30 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendLabel, children: t('myPay:text.net') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: Helper_1.Helper.FormatCurrency(props.netPay) })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { backgroundColor: '#f6b93b', marginRight: 6, marginTop: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 10, height: 30 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendLabel, children: t('myPay:text.deduct') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: Helper_1.Helper.FormatCurrency(props.deductions) })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { backgroundColor: '#e55039', marginRight: 6, marginTop: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 10, height: 30 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendLabel, children: t('myPay:text.taxes') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: Helper_1.Helper.FormatCurrency(props.taxes) })] })] })] })] }));
}
;
